const PER_CAPITA = 14900

export const personData = [
  {
    name: 'Tamara Fischer',
    statement: 'Die Reise gehört zu meinem Studium, die muss ich machen.',
    reason: 'fliegt nach Berlin für eine Studienreise',
    flight: ['Zürich', 'Berlin', '487'],
    image: [
      require('images/Tamara_Fischer_h.jpg'),
      require('images/Tamara_Fischer_r.jpg')
    ],
    map: require('images/globe_zrh-txl.svg'),
    direction: 'left',
    text: require('text/tf.mdx'),
    perCapita: PER_CAPITA,
    show: ['trees', 'cars', 'baskets'],
    compensation: {
      trees: [8, 'trees_berlin.svg'],
      meat: [12, 'meat_berlin.svg'],
      cars: [11, 'cars_berlin.svg'],
      baskets: [37018, 'baskets_berlin.svg']
    }
  },
  {
    name: 'Simon Khosla',
    statement:
      'Ja, die Klimaerwärmung besorgt mich schon sehr. Aber die Reise ist ein Must …',
    reason: 'fliegt nach Los Angeles für eine Sitzung',

    flight: ['Zürich', 'Los Angeles', '4414'],
    image: [
      require('images/Simon_Khosla_h.jpg'),
      require('images/Simon_Khosla_l.jpg')
    ],
    map: require('images/globe_zrh-lax.svg'),
    direction: 'right',
    text: require('text/sk.mdx'),
    perCapita: PER_CAPITA,
    show: ['trees', 'cars', 'baskets'],
    compensation: {
      trees: [70, 'trees_la.svg'],
      meat: [110, 'meat_la.svg'],
      cars: [100, 'cars_la.svg'],
      baskets: [335492, 'baskets_la.svg']
    }
  },
  {
    name: 'Jade Perry',
    age: '',
    job: 'Berater',
    statement:
      'Kompensation? Da müsste ich schon genau wissen, wofür mein Geld dann eingesetzt wird.',
    reason: 'fliegt aus den Ferien in der Schweiz zurück nach London',
    flight: ['Zürich', 'London', '573'],
    image: [
      require('images/Jade_Perry_h.jpg'),
      require('images/Jade_Perry_r.jpg')
    ],
    map: require('images/globe_zrh-lhr.svg'),
    direction: 'left',
    text: require('text/jp.mdx'),
    perCapita: PER_CAPITA,
    show: ['trees', 'meat', 'baskets'],
    compensation: {
      trees: [9, 'trees_london.svg'],
      meat: [14, 'meat_london.svg'],
      cars: [13, 'cars_london.svg'],
      baskets: [43536, 'baskets_london.svg']
    }
  }
]

export const travelData = [
  {
    flight: ['Zürich', 'New York', '2928'],
    map: require('images/globe_zrh-ewr.svg'),
    perCapita: PER_CAPITA,
    show: ['trees', 'cars', 'baskets'],
    compensation: {
      trees: [47, 'trees_newyork.svg'],
      meat: [73, 'meat_newyork.svg'],
      cars: [66, 'cars_newyork.svg'],
      baskets: [222576, 'baskets_newyork.svg']
    }
  },
  {
    flight: ['Zürich', 'Bangkok', '4180'],
    map: require('images/globe_zrh-bkk.svg'),
    perCapita: PER_CAPITA,
    show: ['trees', 'meat', 'baskets'],
    compensation: {
      trees: [66, 'trees_bangkok.svg'],
      meat: [104, 'meat_bangkok.svg'],
      cars: [95, 'cars_bangkok.svg'],
      baskets: [317735, 'baskets_bangkok.svg']
    }
  }
]
